// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "article.listTable.big.big2.big3.mainforMobile table tbody tr td a:hover:after{display:block}article.listTable.big.big2.big3.mainforMobile table tbody tr td a:after{content:\"\";border-bottom:1px solid #000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
